module.exports = __webpack_public_path__ + "img/translate.c131c7d0.png";